exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DVRBackLink_component_zZ1d {\n  padding: 20px 0;\n\n  font-size: 21px;\n  line-height: 1;\n}\n\n.DVRBackLink_homeTitle_Jai1 {\n  padding-left: 22px;\n}\n\n.DVRBackLink_backLink_sgwP {\n  position: relative;\n  padding-left: 22px\n}\n\n.DVRBackLink_backLink_sgwP::before {\n  position: absolute;\n  top: 5px;\n  left: 5px;\n  width: 13px;\n  height: 13px;\n  border: solid #787878;\n  border-width: thin 0 0 thin;\n  -webkit-transform: rotate(-45deg);\n          transform: rotate(-45deg);\n  -webkit-transform-origin: 50% 50%;\n          transform-origin: 50% 50%;\n  content: '';\n}\n", ""]);

// exports
exports.locals = {
	"component": "DVRBackLink_component_zZ1d",
	"homeTitle": "DVRBackLink_homeTitle_Jai1",
	"backLink": "DVRBackLink_backLink_sgwP"
};